import { Flex, Textarea } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";
import useRiskScore from "../../../../hooks/useRiskScore";

const OnboardingStep41 = ({ formData, handleChange }) => {

  const { handleScoreChange } = useRiskScore();

  return (
    <>

      {/* Business Risk */}
      <Flex direction="column" gap={8}>
        <h6>Business Risk</h6>
        <Flex direction="column">
          <Fieldset
            label="Business Model"
            description="Specify the business model of the fund and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("businessRisk", "businessModel", e.target.value)
            }
            input={
              <Textarea
                name="businessModel"
                placeholder="Enter business model"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Management Experience"
            description="Specify the management experience of the fund and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("managementExperience", "businessModel", e.target.value)
            }
            input={
              <Textarea
                name="managementExperience"
                placeholder="Enter management experience"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Ownership Structure"
            description="Specify the ownership structure of the fund and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("ownershipStructure", "businessModel", e.target.value)
            }
            input={
              <Textarea
                name="ownershipStructure"
                placeholder="Enter ownership structure"
                onChange={handleChange}
              />
            }
          />
        </Flex>
      </Flex>

      {/* Market Risk */}
      <Flex direction="column" gap={8}>
        <h6>Market Risk</h6>
        <Flex direction="column">
          <Fieldset
            label="Strategy Complexity"
            description="Specify the strategy complexity and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("strategyComplexity", "marketRisk", e.target.value)
            }
            input={
              <Textarea
                name="strategyComplexity"
                placeholder="Enter strategy complexity"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Market Volatility"
            description="Specify the market volatility and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("marketVolatility", "marketRisk", e.target.value)
            }
            input={
              <Textarea
                name="marketVolatility"
                placeholder="Enter market volatility"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Liquidity Profile"
            description="Specify the liquidity profile and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("liquidityProfile", "marketRisk", e.target.value)
            }
            input={
              <Textarea
                name="liquidityProfile"
                placeholder="Enter liquidity profile"
                onChange={handleChange}
              />
            }
          />
        </Flex>
      </Flex>

      {/* Operational Risk */}
      <Flex direction="column" gap={8}>
        <h6>Operational Risk</h6>
        <Flex direction="column">
          <Fieldset
            label="Process Robustness"
            description="Specify the process robustness and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("processRobustness", "operationalRisk", e.target.value)
            }
            input={
              <Textarea
                name="processRobustness"
                placeholder="Enter process robustness"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Service Provider Quality"
            description="Specify the service provider quality and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("serviceProviderQuality", "operationalRisk", e.target.value)
            }
            input={
              <Textarea
                name="serviceProviderQuality"
                placeholder="Enter service provider quality"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Systems & Controls"
            description="Specify the systems & controls and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("systemsAndControls", "operationalRisk", e.target.value)
            }
            input={
              <Textarea
                name="systemsAndControls"
                placeholder="Enter systems & controls"
                onChange={handleChange}
              />
            }
          />
        </Flex>
      </Flex>

      {/* Compliance Risk */}
      <Flex direction="column" gap={8}>
        <h6>Compliance Risk</h6>
        <Flex direction="column">
          <Fieldset
            label="Regulatory Framework"
            description="Specify the regulatory framework and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("regulatoryFramework", "complianceRisk", e.target.value)
            }
            input={
              <Textarea
                name="regulatoryFramework"
                placeholder="Enter regulatory framework"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Investment Restrictions"
            description="Specify the investment restrictions and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("investmentRestrictions", "complianceRisk", e.target.value)
            }
            input={
              <Textarea
                name="investmentRestrictions"
                placeholder="Enter investment restrictions"
                onChange={handleChange}
              />
            }
          />

          <Fieldset
            label="Investor Base"
            description="Specify the investor base and set a score"
            riskScore={true}
            onScoreChange={(e) =>
              handleScoreChange("investorBase", "complianceRisk", e.target.value)
            }
            input={
              <Textarea
                name="investorBase"
                placeholder="Enter investor base"
                onChange={handleChange}
              />
            }
          />
        </Flex>
      </Flex>
    </>
  );
};

export default OnboardingStep41;
